<div class="mmu-move-reduced-frame-gray">
  <header class="mmu-move-reduced-frame-gray__header">
    <mmu-browser-support-banner>
      <!-- This component will hide itself when not required -->
    </mmu-browser-support-banner>
    <mmu-maintenance-banner>
      <!-- This component will hide itself when not required -->
    </mmu-maintenance-banner>
    <a id="miele-logo" href="/" class="mmu-move-reduced-frame-gray__header__logo mui-logo"></a>
  </header>
  <main class="mmu-move-reduced-frame-gray__content container" [@routeAnimations]="componentName">
    <router-outlet (activate)="activateChildComponent($event)"></router-outlet>
  </main>
  <mmu-footer class="mmu-move-reduced-frame-gray__footer container"></mmu-footer>
</div>
